module.exports = __webpack_public_path__ + "static/media/We-Negotiate.fe9d5aed.png";